<template>
  <footer class="PageFooter">
		<div class="foot-inner">
			<div class="container">
				<div class="row">
					<div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
					<a href="https://learnapp.co/home/?ref=APPRDD"><img src="@/assets/img/logo.png" height="40px" /></a>
				</div>
			</div>

			<div class="foot-link">
				<div class="row">
					<div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
            <h4>Company</h4>
            <ul>
              <li><a href="https://learnapp.co/about-us/?ref=APPRDD">About Us</a></li>
              <li><a href="https://learnapp.co/courses/all/?ref=APPRDD">All Courses</a></li>
              <li><a href="https://learnapp.co/live/all/?ref=APPRDD">Live Classes</a></li>
            </ul>
          </div>

          <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
            <h4>Support</h4>
            <ul>
              <li><a href="https://learnapp.co/contact-us/?ref=APPRDD">Contact Us</a></li>
              <li><a href="https://learnapp.co/privacy-policy/?ref=APPRDD">Privacy Policy</a></li>
              <li><a href="https://learnapp.co/terms-of-service/?ref=APPRDD">Terms & Conditions</a></li>
              <li><a href="https://learnapp.co/refund-and-cancellation/?ref=APPRDD">Refund Policy</a></li>
            </ul>
          </div>
			  </div>
		  </div>

      <div class="row social-links">
        <div class="col-xl-6 col-lg-6 col-md-7 col-sm-12 col-12">
          <p>@ 2018 LearnApp  | Proudly Made in India <img src="@/assets/img/flag.png" /></p><br>
          <p>Universal Financial Education</p>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-5 col-sm-12 col-12">
          <ul class="social">
            <li><a href="https://twitter.com/LearnApp_co" target="_blank" class="twitter"><i class="fa fa-twitter"></i></a></li>
            <li><a href="https://www.facebook.com/LearnApp" target="_blank" class="facebook"><i class="fa fa-facebook"></i></a></li>
            <li><a href="https://www.youtube.com/learnapp" target="_blank" class="youtube"><i class="fa fa-youtube"></i></a></li>
            <li><a href="https://www.instagram.com/learnapp_co" target="_blank" class="instagram"><i class="fa fa-instagram"></i></a></li>
          </ul>
        </div>
      </div>
		</div>
	</div>
	</footer>
</template>

<script>
export default {
  name: 'PageFooter',
  props: {},
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.PageFooter {
  background-image: linear-gradient(
    to top,
    rgba(248, 252, 255, 0.59),
    rgba(229, 244, 255, 0.59)
  );
  border-top: 2px solid #e6eaed;
  padding: 85px 0 0px;
  position: relative;
  top: 100px;

  .foot-inner {
    background: url("../../../assets/img/footer-bg.png") no-repeat right bottom;
    padding-bottom: 180px;
    background-size: 40rem auto;
  }

  .foot-link {
    padding: 140px 0;
  }

  .foot-link h4 {
    font-size: 22px;
    line-height: 22px;
    font-weight: 600;
    color: #28282e;
    margin: 0 0 30px;
  }

  .foot-link ul {
    margin: 0;
  }

  .foot-link ul li {
    margin: 0 0 15px;
    line-height: 100%;
  }

  .foot-link ul li a {
    line-height: 100%;
    opacity: 0.73;
    font-size: 18px;
    color: #5e6977;
    font-weight: normal;
  }

  .foot-link ul li a:hover {
    opacity: 1;
  }

  p {
    color: rgba(94, 105, 119, 0.77);
    font-size: 16px;
    margin: 0;
    line-height: 100%;
  }

  .social {
    display: inline-flex;
    float: right;
    margin-right: 70px;
  }

  .social li {
    height: 40px;
    width: 40px;
    font-size: 0;
    background-color: #fff;
    text-align: center;
    position: relative;
    top: 0;
    bottom: 0;
    border-radius: 28%;
    left: 0;
    right: 0;
    margin: 0 12px;
    box-shadow: 0 5px 15px -5px rgba(0, 0, 0, 0.1);
  }
  .social li .facebook {
    color: #3b5998;
  }
  .social li .twitter {
    color: #3cf;
  }
  .social li .instagram {
    color: #e4405f;
  }
  .social li .youtube {
    color: #cd201f;
  }

  .social li .facebook:hover,
  .social li .twitter:hover,
  .social li .instagram:hover,
  .social li .youtube:hover {
    color: white;
  }

  .social li a::after {
    position: absolute;
    content: "";
    top: 0;
    left: 0;
    width: 0;
    height: 100%;
    border-radius: 28%;
    transform-origin: left;
    transition: width 0.25s;
    z-index: -1;
  }
  .social li .facebook::after {
    background-color: #3b5998;
  }
  .social li .twitter::after {
    background-color: #3cf;
  }
  .social li .instagram::after {
    background-color: #e4405f;
  }
  .social li .youtube::after {
    background-color: #cd201f;
  }

  .social li a:hover::after {
    width: 100%;
    // transition: width .35s ease;
    // transition-timing-function: cubic-bezier(0.54, 0.52, 0.54, 0.53);
  }

  .social li a {
    color: #fff;
    opacity: 0.82;
    font-size: 26px;
  }

  .social-links {
    margin-right: -10%;
  }

  p img {
    vertical-align: top;
  }
}
/*** Responsive ***/
@media (max-width: 1300px) {
  .PageFooter .social-links {
    margin-right: 0;
  }
}
@media (max-width: 991px) {
  .foot-inner {
    background-size: 500px auto;
  }

  .social {
    margin-right: -46px;
  }
}
@media (max-width: 767px) {
  .foot-link .col-12 {
    margin-bottom: 25px;
  }

  .foot-inner {
    background-size: 100% auto;
  }

  .foot-inner .col-xl-6 {
    text-align: center;
  }

  p {
    color: #fff;
    position: relative;
    top: 120px;
  }

  .social {
    margin-right: 0;
    float: none;
    text-align: center;
  }

  .social li {
    float: none;
    margin: 0 10px 0;
    display: inline-block;
  }

  .social li a {
    font-size: 30px;
  }
}
@media (max-width: 575px) {
  .PageFooter {
    margin-bottom: 15px;
    margin: 15px;
    top: 100px;
  }
  .foot-inner {
    background-size: 100% 450px;
  }

  p {
    line-height: 23px;
    top: 150px;
    font-size: 15px;
    margin-left: 45px;
  }
  .social {
    margin-right: -20px;
  }
  .social li a {
    font-size: 18px;
  }
  .social li[data-v-efe9bb8c] {
    height: 30px;
    width: 30px;
    margin: 0 7px 0;
  }
}
@media (max-width: 375px) {
  .PageFooter {
    top: 100px;
    p {
      top: 191px;
    }
    .social {
      margin-right: 3px;
    }
  }
}
.LandingLayout .PageFooter {
  top: 120px;
}
</style>



// WEBPACK FOOTER //
// src/modules/Home/components/PageFooter.vue